import React from 'react';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import cN from 'classnames';
import './index.less';

interface IProps {
  onChange: (num: number) => void;
  onFocus: () => void;
  onBlur: () => void;
  autoFocus: boolean;
  value?: number;
  min?: number;
  max?: number;
  step?: 1;
  disabled?: boolean;
}

const NumericInput = ({ value, min, max, step, disabled, autoFocus, onChange, onFocus, onBlur }: IProps) => {
  const _step = step ?? 1;

  const update = (num: number): void => {
    onChange(Number.isNaN(num) ? 0 : num);
  };

  const getNumValue = (val: string, min: number) => Math.max(+val, min || -1);

  return (
    <span
      className={cN('pietra-numeric-input', {
        highlight: value > 0,
      })}
    >
      <Input.Group compact>
        <MinusOutlined
          className="decrement"
          onClick={() => {
            if (value - _step < min) {
              update(0);
            } else {
              update(value - _step);
            }
          }}
        />
        <Input
          autoFocus={autoFocus}
          type="number"
          step={_step}
          min={0}
          max={max}
          disabled={disabled}
          value={value}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={(e) => {
            if (!e.target.value || getNumValue(e.target.value, min)) {
              update(min);
            } else {
              update(parseInt(e.target.value));
            }
          }}
          aria-label="The quantity of samples"
        />
        <PlusOutlined
          className="increment"
          onClick={() => {
            if (value + _step > max) {
              update(max);
            } else {
              update(value + _step);
            }
          }}
        />
      </Input.Group>
    </span>
  );
};

export default NumericInput;
